var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrossAmountFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.325 9.08333C8.43333 8.59167 7.825 8.08333 7.825 7.29167C7.825 6.38333 8.66666 5.75 10.075 5.75C11.5583 5.75 12.1083 6.45833 12.1583 7.5H14C13.9417 6.06667 13.0667 4.75 11.325 4.325V2.5H8.825V4.3C7.20833 4.65 5.90833 5.7 5.90833 7.30833C5.90833 9.23333 7.5 10.1917 9.825 10.75C11.9083 11.25 12.325 11.9833 12.325 12.7583C12.325 13.3333 11.9167 14.25 10.075 14.25C8.35833 14.25 7.68333 13.4833 7.59166 12.5H5.75833C5.85833 14.325 7.225 15.35 8.825 15.6917V17.5H11.325V15.7083C12.95 15.4 14.2417 14.4583 14.2417 12.75C14.2417 10.3833 12.2167 9.575 10.325 9.08333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossAmountFilter);
export default __webpack_public_path__ + "static/media/gross-amount-filter.87a0f524c05e4fe65b9a886774ae2ade.svg";
export { ForwardRef as ReactComponent };